import {createI18n} from '@soopkr-fe/soop-i18n';
import '@soopkr-fe/soop-i18n/main/common';

const i18n = createI18n({
  namespaces: ['main/common'],
});

export const CommonT = i18n.t;
export const CommonI18n = i18n;
